<template>
  <b-modal
        scrollable
    id="delete-article-in-pending-modal-internal"
    ref="modal"
    header-class="headerModal"
    centered
    size="s"
    :title="`${$t('DeleteArticleInPending')}: ${clickedArticleNumber}`"
    hide-footer
    @hide="onCancel"
  >
    <div>
      <span
        style="color: #262E6C; font-weight: bold;"
      >
        {{ $t('AreUSureUWantDeleteArticleInPending') }}
      </span>
    </div>
    <div class="buttonsEverywhere">
      <button
        type="button"
        variant="none"
        style="margin-left: 0px;"
        class="buttonSubmit"
        @click="onSubmit"
      >
      <div
          v-if="loading"
          style="width:100%"
          class="pdf-spinner-overlay"
        >
          <span class="loader" />
        </div>
        {{ $t('Submit') }}
      </button>
      <b-button
        type="reset"
        variant="danger"
        class="buttonCancel"
        style="margin-right: 15px; background: white; color: black; border-color: white;font-weight: 400;"
        @click="onCancel"
      >
        {{ $t('Cancel') }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'


export default {
  props: ['clickedProductMovementId', 'clickedArticleNumber'],
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    ...mapGetters([
    ]),
  },
  methods: {
    ...mapActions([
      'loadDeleteProductsInStockMovementId',
    ]),
    async onSubmit() {
      try {
        this.loading = true
        await this.loadDeleteProductsInStockMovementId({
          productInStockMovementId: this.clickedProductMovementId,
          successCallback: () => {
            this.loading = false
            this.$refs.modal.hide();
            this.onReset();
            this.$emit('updateProductsInStockMovement');
          },
        });
      } catch (error) {
        this.loading = false
      }
    },
    onCancel() {
      this.onReset();
    },
    onReset() {
      this.loading = false
      this.$refs.modal.hide();
    },
  },
}
</script>

      <style lang="scss" scoped>

      </style>
